/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateKeyValueRequest
 */
export interface CreateKeyValueRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateKeyValueRequest
     */
    value?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateKeyValueRequest
     */
    expires?: Date | null;
}

/**
 * Check if a given object implements the CreateKeyValueRequest interface.
 */
export function instanceOfCreateKeyValueRequest(value: object): value is CreateKeyValueRequest {
    return true;
}

export function CreateKeyValueRequestFromJSON(json: any): CreateKeyValueRequest {
    return CreateKeyValueRequestFromJSONTyped(json, false);
}

export function CreateKeyValueRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateKeyValueRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'expires': json['expires'] == null ? undefined : (new Date(json['expires'])),
    };
}

export function CreateKeyValueRequestToJSON(json: any): CreateKeyValueRequest {
    return CreateKeyValueRequestToJSONTyped(json, false);
}

export function CreateKeyValueRequestToJSONTyped(value?: CreateKeyValueRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'expires': value['expires'] == null ? value['expires'] : value['expires'].toISOString(),
    };
}

